import axios from "axios";
import authHeader from "./auth-header";

const API_URL = process.env.REACT_APP_API_URL_BASE + "api/observability/";

export async function getOverview() {
  const res = await axios.get(API_URL + "overview", { headers: authHeader() });
  return res.data;
}

export async function getReconToday() {
  const res = await axios.get(API_URL + "recon/today", { headers: authHeader() });
  return res.data;
}

export async function getReconHistory() {
  const res = await axios.get(API_URL + "recon/history", { headers: authHeader() });
  return res.data;
}

export async function getReconForDate(date) {
  const res = await axios.get(API_URL + "recon/" + date, { headers: authHeader() });
  return res.data;
}
